import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Button, Container } from 'react-bootstrap'
import { debounce, isBottomReached } from '@shared-submodule/utils'
import { useRouter } from 'next/router'
import styles from './style.module.scss'
// import CustomPagination from '@shared/components/custom-pagination'
import { useLazyQuery } from '@apollo/client'
import { GET_TEAM_LIST_WITH_SERIES, TEAM_LIST_WITH_FILTERS } from '@shared-submodule/sm-graphql/teams/teams.query'

const TeamsFilter = dynamic(() => import('@shared/components/team/TeamsFilter'))
const TeamCards = dynamic(() => import('./teamCards'))
const NoData = dynamic(() => import('@shared/components/noData'))

export default function TeamsList({ allTeams, filteredTeams, isFiltered }) {
  const router = useRouter()

  const payload = useRef({ ...router?.query, nLimit: 24, nSkip: 0 })
  const [isAllTeam, setIsAllTeam] = useState(!filteredTeams?.length && !isFiltered)
  const [teamList, setTeamList] = useState(isAllTeam ? allTeams : filteredTeams)
  const [enableBtn, setEnableBtn] = useState(filteredTeams?.length >= 24)
  const btnDisabled = useRef(false)

  const [getFilters] = useLazyQuery(TEAM_LIST_WITH_FILTERS)

  function onCompleted(data) {
    const lastItem = data?.listTeamsWithFilters?.[data?.listTeamsWithFilters?.length - 1]
    const id = `${lastItem?._id}`
    if (btnDisabled.current) {
      isBottomReached(id, isReached)
    }
    setIsAllTeam(false)
    if (payload.current.nSkip > 0) {
      setEnableBtn(data?.listTeamsWithFilters?.length >= 24)
      setTeamList(prev => [...prev, ...(data?.listTeamsWithFilters || [])])
    } else {
      btnDisabled.current = false
      setEnableBtn(data?.listTeamsWithFilters?.length >= 24)
      setTeamList(data?.listTeamsWithFilters)
    }
  }

  async function isReached(reach) {
    if (reach) {
      payload.current.nSkip += 24
      setEnableBtn(false)
      getFilters({ variables: { input: { ...payload.current } } }).then((data) => onCompleted(data.data))
    }
  }

  const [getAllTeamsData] = useLazyQuery(GET_TEAM_LIST_WITH_SERIES)

  function handleFilterChange(filter, type) {
    btnDisabled.current = false
    payload.current.nSkip = 0
    if (type === 'clear' || !filter) {
      setEnableBtn(false)
      payload.current = { nLimit: 24, nSkip: 0 }
      if (allTeams?.length) {
        setIsAllTeam(true)
        setTeamList(allTeams)
        router.push({ query: {} }, null, { shallow: true })
      } else {
        getAllTeamsData().then((data) => {
          setIsAllTeam(true)
          setTeamList(data?.data.listTeamsByPopularSeries || [])
          router.push({ query: {} }, null, { shallow: true })
        })
      }
    } else {
      payload.current[type] = filter?.sValue
      getFilters({ variables: { input: { ...payload.current } } }).then((data) => {
        onCompleted(data.data)
        router.push({ query: { ...router?.query, [type]: filter?.sValue } }, null, { shallow: true })
      })
    }
  }
  const handleLoadMore = () => {
    payload.current.nSkip += 24
    btnDisabled.current = true
    setEnableBtn(false)
    getFilters({ variables: { input: { ...payload.current } } }).then((data) => onCompleted(data.data))
  }

  const handleSearchChange = debounce(function handleSearchChange(sSearch) {
    if (sSearch) {
      payload.current.nSkip = 0
      payload.current.sSearch = sSearch
      getFilters({ variables: { input: { ...payload.current } } }).then((data) => {
        onCompleted(data.data)
        router.push({ query: { ...router?.query, sSearch } }, null, { shallow: true })
      })
    } else {
      setEnableBtn(false)
      const query = { ...router?.query }
      delete query?.sSearch
      if (Object.keys(query)?.length) {
        delete payload.current.sSearch
        getFilters({ variables: { input: { ...payload.current, nLimit: 24, nSkip: 0 } } }).then((data) => {
          onCompleted(data.data)
          router.push({ query }, null, { shallow: true })
        })
      } else {
        if (allTeams?.length) {
          setIsAllTeam(true)
          setTeamList(allTeams)
          router.push({}, null, { shallow: true })
        } else {
          getAllTeamsData().then((data) => {
            setIsAllTeam(true)
            setTeamList(data?.data.listTeamsByPopularSeries || [])
            router.push({ query: {} }, null, { shallow: true })
          })
        }
      }
    }
  })

  return (
    <>
      <TeamsFilter defaultValues={router?.query} handleFilterChange={handleFilterChange} handleSearchChange={handleSearchChange} />
      <div className={`${styles.teamList} border-0 rounded-0 mb-0 pt-0`}>
        <Container className='mt-1'>
          {!teamList?.length ? <div className='pb-3'>
            <NoData title="No teams making waves at the moment... but we’re ready for the storm!"/>
          </div> : null}
          {isAllTeam ? teamList?.map((data) => {
            return (
              <div key={data?.oSeries?._id} className='mt-3'>
                <h6 className={styles.seriesName}>{data?.oSeries?.sTitle}</h6>
                <TeamCards teamsList={data?.aTeams} />
              </div>
            )
          }) : <TeamCards teamsList={teamList} />
          }
        </Container>
        {enableBtn && <div className="text-center my-3">
          <Button className="theme-btn" onClick={handleLoadMore}>{'Load more'}</Button>
        </div>
        }
      </div >

    </>
  )
}

TeamsList.propTypes = {
  allTeams: PropTypes.array,
  filteredTeams: PropTypes.array,
  isFiltered: PropTypes.bool
}
